import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FilerrUploader, PolicyValidationError } from '@fiverr/filerr_uploader';
import './style.scss';

/**
 * @class
 * @name ProfileImage
 * @extends Component
 * @param {Object} user - all the user data
 * @param {Boolean} allowEditing - whether the user can edit
 * @param {String} authToken - Fiverr authentication token
 * Returns the markup of the user profile image
 */

class ProfileImage extends Component {

    constructor(props) {
        super(props);

        this.state = {
            file: null,
            saving: false,
            newImage: ''
        };

        this.onInputChange = this.onInputChange.bind(this);
        this.displayImage = this.displayImage.bind(this);
    }

    onInputChange(e) {

        const file = e.target.files[0];

        if (!file) {
            return;
        }

        this.setState({
            file,
            saving: true
        }, () => {
            this.directUploadFile();
        });
    }

    displayImage(fileUrl) {

        this.setState({
            file: null,
            saving: false,
            newImage: fileUrl
        });

    }

    directUploadFile() {

        const saveImage = ({ key, bucketName }) => {
            const saveImageTime = Date.now();
            const formDataTemp = new FormData();
            formDataTemp.append('authenticity_token', this.props.authToken);
            formDataTemp.append('s3_file_path', key);
            formDataTemp.append('bucket_name', bucketName);

            return fetch('/profiles/update_photo', {
                method: 'POST',
                body: formDataTemp,
                headers: new Headers({
                    'Accept': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                    'X-CSRF-Token': this.props.authToken
                }),
                credentials: 'same-origin'
            }).then((response) => response.json())
                .then((data) => {

                    Fiverr._broadcastLogEvents({
                        facility: 'graphite',
                        type: 'timing',
                        label: 'profile.filerr.seller_page.update_photo',
                        value: (Date.now() - saveImageTime)
                    });

                    return data;
                })
                .catch((err) => {

                    Fiverr._logEventToGraphite({
                        label: 'profile.filerr.seller_page.ajax.s3_upload.error',
                        percentage: 100
                    });

                    Fiverr._logErrorToServer('seller_card_package', 'Seller Filerr photo', `[s3_direct_upload] ${err.responseText}, status:${err.status}`);
                });
        };

        const filerrUploaderOptions = {
            objectName: 'profile',
            attachmentName: 'photo',
            getPolicyUrl: '/attachments/policy'
        };

        const uploadOptions = {
            file: this.state.file,
            onSuccess: (s3UploadedData) => {
                saveImage(s3UploadedData).then((savedImageData) => {
                    this.displayImage(savedImageData.url);
                });
            },
            onError: (err) => {
                if (err instanceof PolicyValidationError) {
                    this.setState({
                        file: null,
                        saving: false,
                        newImage: ''
                    });
                }
            }
        };

        const filerrUploader = new FilerrUploader(filerrUploaderOptions);
        filerrUploader.upload(uploadOptions);
    }

    render() {

        const {
            user,
            allowEditing
        } = this.props;

        const showUserBadge = user.is_seller && user.achievement && (user.achievement > 0),
            badgeClasses = [
                { rating: 0, class: 'no_level_seller' },
                { rating: 1, class: 'level_one_seller' },
                { rating: 2, class: 'level_two_seller' },
                { rating: 5, class: 'top_rated_seller' }
            ],
            badgeClass = showUserBadge ? badgeClasses.find((b) => b.rating === user.achievement).class : '',
            newImage = this.state.newImage,
            hasImage = user.has_profile_photo || newImage,
            userNameLetter = user.username ? user.username.substring(0, 1) : 'x';

        let userImage,
            labelClass = '';

        if (allowEditing && !this.state.saving) {
            labelClass = 'editable';
        } else if (this.state.saving) {
            labelClass = 'loading';
        }

        if (hasImage) {
            userImage = <img src={newImage ? newImage : user.profile_photo} className="user-pict-img" alt={user.username} width="150" height="150"/>;
        } else {
            userImage = <span className="missing-image-user">{userNameLetter}</span>;
        }

        return (
            <label className={`user-pict-150 ${labelClass}`} htmlFor="profile_image">

                {allowEditing &&
                <input accept="image/png,image/jpeg" className="hidden" onChange={this.onInputChange} id="profile_image" name="profile[image]" type="file"/>
                }

                {userImage}

                {showUserBadge &&
                <a href="/levels" className={`user-badge-round-med ${badgeClass}`}></a>
                }

            </label>
        );

    }

}

ProfileImage.propTypes = {
    user: PropTypes.object.isRequired,
    allowEditing: PropTypes.bool.isRequired,
    authToken: PropTypes.string.isRequired
};

export default ProfileImage;



// WEBPACK FOOTER //
// ./src/components/profile_image/index.js